var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"map-block"},[_c('div',{staticClass:"map"},[_c('div',{ref:"map",staticClass:"map-inner"})])])}
var staticRenderFns = []

export { render, staticRenderFns }